import { deepCopy } from "../entities/XmlEditor/XmlEditor"

export const accidentalDom: { [name: string]: (x: number, y: number) => string } = {
   sharp: (x: number, y: number) => {
      return `<path transform="translate(${x}, ${y}) scale(1,-1)" d="${accidentalsDomD['sharp']}"></path>`
   },
   natural: (x: number, y: number) => {
      return `<path transform="translate(${x}, ${y}) scale(1,-1)" d="${accidentalsDomD['natural']}"></path>`
   },
   flat: (x: number, y: number) => {
      return `<path transform="translate(${x}, ${y}) scale(1,-1)" d="${accidentalsDomD['flat']}"></path>`
   },
   /*
   doubleSharp: (x: number, y: number) => {
      return ``
   },
   sharpSharp: (x: number, y: number) => {
      return ``
   },
   flatFlat: (x: number, y: number) => {
      return ``
   }
   */
}
export const accidentalsDomD: { [name: string]: string } = {
   sharp: `M136 186v169h17v-164l44 14v-91l-44 -14v-165l44 12v-91l-44 -13v-155h-17v150l-76 -22v-155h-17v149l-43 -13v90l43 14v167l-43 -14v92l43 13v169h17v-163zM60 73v-167l76 22v168z`,
   natural: `M0 -188v539h18v-191l139 22v-533h-17v186zM18 -100l122 17v176l-122 -19v-174z`,
   flat: `M20 110c32 16 54 27 93 27c26 0 35 -3 54 -13c13 -7 24 -20 27 -38l4 -25c0 -28 -16 -57 -45 -89c-23 -25 -39 -44 -65 -68l-88 -79v644h20v-359zM90 106c-32 0 -48 -10 -70 -29v-194c31 31 54 59 71 84c21 32 32 59 32 84c0 9 1 16 1 20c0 14 -3 21 -11 30l-8 3z`,
}
const accidentalStatic = {
   elements: [
      {
         type: 'text',
         text: 'natural'
      }
   ],
   name: 'accidental',
   type: 'element'
};
export const accidentaJs2Xml = (name: string) => {
   const result = deepCopy(accidentalStatic);
   result.elements[0].text = name;
   return result;
}

export const fingerDom = (x: number, y: number, fingNum: number) => `<g class="fing" fill="#000000" stroke="#000000">
<text x="${x}" y="${y}" text-anchor="middle" font-size="0px" fill="#000000" stroke="#000000">
   <tspan id="t1aexkgc" class="text" fill="#000000" stroke="#000000">
      <tspan font-size="303px" fill="#000000" stroke="#000000">${fingNum}</tspan>
   </tspan>
</text>
</g>`
